<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d61713422e59b-d1e220"><span id="pageii">
<h3 class="books-by-head"><em class="italic ">The Liberty Lane Series from Caro Peacock</em></h3>
<p class="books-by-text">DEATH AT DAWN</p>
<p class="books-by-text-space-after"><em class="italic ">(USA: A FOREIGN AFFAIR)</em></p>
<p class="books-by-text">DEATH OF A DANCER</p>
<p class="books-by-text-space-after"><em class="italic ">(USA: A DANGEROUS AFFAIR)</em></p>
<p class="books-by-text">A CORPSE IN SHINING ARMOUR</p>
<p class="books-by-text-space-after"><em class="italic ">(USA: A FAMILY AFFAIR)</em></p>
<p class="books-by-text-space-after">WHEN THE DEVIL DRIVES *</p>
<p class="books-by-text-space-after">KEEPING BAD COMPANY *</p>
<p class="books-by-text-space-after">THE PATH OF THE WICKED *</p>
<p class="books-by-text-space-after">FRIENDS IN HIGH PLACES *</p>
<p class="books-by-text"><em class="italic ">* available from Severn House</em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106601_epub_alb.vue?39c47953